export default __webpack_public_path__ + "static/media/gallery_09.ef2855e8.jpg";